<template>
	<main-page :color="pageColor" :hide-footer="!selectedRole">
		<template v-slot:title>
			Sign Up
		</template>

		<div class="container">
			<template v-if="!matchedCode">
				<!-- Select role -->
				<template v-if="!selectedRole">
					<h1 class="si-font mt-5 pb-0">Please Choose a Role</h1>
					<div class="d-flex flex-column align-items-center">
						<div>
							<div
								class="card mt-4 text-center clickable clickable-card limited-width si-green text-white"
								@click="pickRoleStudent"
							>
								<h1 class="py-4 px-5">
									<i class="fas mr-3" :class="{ [fs.roleIcon('STUDENT')]: true }" />Student
								</h1>
							</div>
							<div
								class="card mt-4 text-center clickable clickable-card limited-width si-blue text-white"
								@click="pickRoleTeacher"
							>
								<h1 class="py-4 px-5">
									<i class="fas mr-3" :class="{ [fs.roleIcon('TEACHER')]: true }" />Teacher
								</h1>
							</div>
							<div
								class="card mt-4 text-center clickable clickable-card limited-width si-orange text-white"
								@click="pickRolePartner"
							>
								<h1 class="py-4 px-5">
									<i class="fas mr-3" :class="{ [fs.roleIcon('PARTNER')]: true }" />Community Partner
								</h1>
							</div>
														<div
								class="card mt-4 text-center clickable clickable-card limited-width si-pink text-white"
								@click="pickRoleJudge"
							>
								<h1 class="py-4 px-5">
									<i class="fas mr-3" :class="{ [fs.roleIcon('JUDGE')]: true }" />Judge
								</h1>
							</div>
						</div>
					</div>
				</template>

				<!-- Enter code -->
				<div v-if="selectedRole" class="px-4 pb-4 mt-5">
					<label class="si-font large-label mb-4" style="font-size: 40px;">Enter Join Code:</label>
					<input
						ref="codeInput"
						class="form-control text-center black-border code-entry"
						:class="{ 'is-invalid': codeFailed }"
						v-model="code"
					/>
					<div v-if="codeFailed" class="text-danger text-lg mt-2">
						Invalid Join Code
					</div>
					<div class="mt-4">
						<button
							v-if="!joining && !validCode"
							@click="checkJoinCode()"
							class="btn btn-lg btn-no-border btn-si-gray flex"
							disabled
						>
							Join as {{ fs.roleName(selectedRole) }}
						</button>
						<button
							v-if="!joining && validCode"
							@click="checkJoinCode()"
							class="btn btn-lg btn-no-border btn-si-green flex"
						>
							Join as {{ fs.roleName(selectedRole) }}
						</button>
						<button v-if="joining" class="btn btn-lg si-btn-green text-white flex" disabled>
							Checking Code...
							<loading type="icon" />
						</button>
					</div>
				</div>
			</template>

			<template v-if="matchedCode">
				<div class="login-box d-flex flex-column justify-content-between mx-auto shadow mt-5 mb-3">
					<div class="si-font" style="font-size: 36px; margin-bottom: 16px; line-height: 1;">
						Connect with Google
					</div>
					<a :href="googleLink" class="my-1 google-button" @click="goingToGoogle = true">
						<img style="width: 280px;" src="@/assets/images/google_sign_in.png" />
						<div class="google-button-overlay">
							<div v-if="goingToGoogle" class="loading-overlay">
								<loading type="medium" />
							</div>
						</div>
					</a>
				</div>
				<h1 class="text-extra-muted text-center si-font">or</h1>
				<form
					@submit.prevent="submit"
					name="form"
					class="login-box d-flex flex-column justify-content-between mx-auto shadow mt-3 mb-5"
				>
					<div class="si-font" style="font-size: 36px; margin-bottom: 16px; line-height: 1;">
						Create an Account
					</div>
					<div v-if="district" class="form-group">
						<label class="text-lg si-font si-text-orange">Organization</label>
						<input
							type="text"
							class="login-input login-input-disabled si-text-green"
							readonly
							disabled
							:value="district.name"
						/>
					</div>
					<div v-if="section" class="form-group">
						<label class="text-lg si-font si-text-orange">Class</label>
						<input
							type="text"
							class="login-input login-input-disabled si-text-blue"
							readonly
							disabled
							:value="section.name"
						/>
					</div>
					<div class="form-group">
						<label class="text-lg si-font si-text-orange">Email</label>
						<input type="text" class="login-input" placeholder="Email" required v-model.trim="email" />
					</div>
					<div class="row">
						<div class="col-6 form-group">
							<label class="text-lg si-font si-text-orange">First Name</label>
							<input
								type="text"
								class="login-input"
								placeholder="First name..."
								required
								v-model.trim="firstName"
							/>
						</div>
						<div class="col-6 form-group">
							<label class="text-lg si-font si-text-orange">Last Name</label>
							<input
								type="text"
								class="login-input"
								placeholder="Last name..."
								required
								v-model.trim="lastName"
							/>
						</div>
					</div>
					<div class="form-group">
						<label class="text-lg si-font si-text-orange">Password</label>
						<input
							type="password"
							class="login-input"
							placeholder="Password"
							required
							v-model.trim="password1"
						/>
					</div>
					<div class="form-group">
						<label class="text-lg si-font si-text-orange">Confirm Password</label>
						<input
							type="password"
							class="login-input"
							placeholder="Password"
							required
							v-model.trim="password2"
						/>
					</div>
					<div class="ml-2 form-group" style="min-height: 28px;">
						<div v-for="(error, i) in passwordErrors" :key="i" class="text-md text-danger">
							<i class="fas fa-exclamation-triangle mr-1" />{{ error }}
						</div>
					</div>
					<div class="d-flex justify-content-between">
						<button class="btn btn-si-orange" style="width: 100%;" type="submit">
							Create Account
						</button>
					</div>
				</form>
			</template>
		</div>

		<template v-slot:footer>
			<div class="col-6 text-right">
				<button v-if="selectedRole" class="btn btn-si-secondary" @click="backToRoleSelect">Back</button>
				<a v-if="!selectedRole" class="btn btn-si-secondary" href="#/login">Back</a>
			</div>
		</template>
		
	</main-page>
</template>

<script>
import MainPage from "@/components/MainPage";
import AuthService from "@/services/AuthService";
import Notie from "@/services/NotieService";
import fs from "@/services/FormatService";

export default {
	name: "DistrictSelect",

	props: [],

	components: { MainPage },

	data() {
		return {
			fs: fs,
			joining: false,

			user: null,
			selectedRole: null,
			code: null,
			codeFailed: false,

			matchedCode: false,
			district: null,
			section: null,

			firstName: null,
			lastName: null,
			email: null,
			password1: null,
			password2: null,
			passwordErrors: [],
		};
	},

	computed: {
		pageColor() {
			switch (this.selectedRole) {
				case "STUDENT":
					return "green";
				case "TEACHER":
					return "blue";
				case "PARTNER":
					return "orange";
				case "JUDGE":
					return "pink";
				default:
					return "yellow";
			}
		},

		validCode() {
			return this.code && this.code.length == 12;
		},

		googleLink() {
			let url = "/v1/auth?provider=g_student";
			if (this.code && this.selectedRole) {
				url = `${url}&role=${this.selectedRole}&code=${this.code}`;
			}

			return url;
		},
	},

	watch: {
		code() {
			this.code = this.code.toUpperCase();
			this.codeFailed = false;
		},

		password1() {
			this.checkValidPassword();
		},

		password2() {
			this.checkValidPassword();
		},
	},

	created() {
		console.log(this.selectedRole)
		AuthService.getUserNoDistrict()
			.then((r) => {
				this.user = r.data;
			})
			.catch((e) => {
				console.log("Error getting user", { error: e });
			});
	},

	methods: {
		checkJoinCode() {
			AuthService.checkJoinCode(this.code, this.selectedRole)
				.then((r) => {
					this.matchedCode = true;
					this.district = r.data.district;
					this.section = r.data.section;

					window.location.href = this.district.host + "/#/signup";
				})
				.catch((e) => {
					console.log(e);
				});
		},

		pickRoleStudent() {
			this.selectedRole = "STUDENT";
		},

		pickRoleTeacher() {
			this.selectedRole = "TEACHER";
		},

		pickRolePartner() {
			this.selectedRole = "PARTNER";
		},

		pickRoleJudge() {
			this.selectedRole = "JUDGE";
		},

		applyJoinCode() {
			this.joining = true;
			AuthService.applyJoinCode(this.code, this.selectedRole)
				.then(() => {
					this.joining = false;
					AuthService.forceRefresh();
					this.goToLandingPage(this.selectedRole);
				})
				.catch((e) => {
					this.joining = false;
					console.log(e);
					this.codeFailed = true;
					this.$refs.codeInput.focus();
				});
		},

		backToRoleSelect() {
			this.selectedRole = null;
			this.code = null;
			this.codeFailed = false;
		},

		goToLandingPage(role) {
			switch (role) {
				case "STUDENT":
					this.$router.replace("/portfolio");
					break;
				case "TEACHER":
					this.$router.replace("/classes");
					break;
				case "PARTNER":
					this.$router.replace("/classes");
					break;
				case "JUDGE":
					this.$router.replace("/pitches");
					break;
			}
		},

		checkValidPassword() {
			this.canSetPassword = false;
			if (!(this.password1 && this.password2)) {
				return;
			}

			// TODO: Other restrictions (length, special characters, etc.)

			if (this.password1 != this.password2) {
				this.passwordErrors = ["The passwords must match"];
				return;
			}

			this.passwordErrors = [];
			this.canSetPassword = true;
		},

		submit() {
			if (this.password1 != this.password2) {
				Notie.error("Cannot create account", "Passwords do not match");
				return;
			}
			if (!this.email) {
				Notie.error("Cannot create account", "Email is required");
				return;
			}
			if (!(this.firstName || this.lastName)) {
				Notie.error("Cannot create account", "Name is required");
			}

			let name = { first: this.firstName, last: this.lastName };
			AuthService.createAccount(this.email, this.password1, name, this.selectedRole, this.code)
				.then(() => {
					AuthService.login(this.email, this.password1)
						.then((resp) => {
							// Successful login, but with redirect message
							if (resp.data) {
								if (resp.data.message == "toDistrictPick") {
									this.$router.push("/district_select");
								} else {
									Notie.error("Unexpected login error");
									console.log("UNEXPECTED LOGIN MESSAGE", resp);
								}
								return;
							}

							// Successful normal login
							let user = resp.user;
							console.log("LOGIN USER", user);
							if (user.role == "ADMIN") {
								this.$router.push("/admin");
							} else if (user.role == "TEACHER") {
								this.$router.push("/classes");
							} else if (user.role == "JUDGE") {
								this.$router.push("/pitches");
							} else {
								this.$router.push("/portfolio");
							}
						})
						.catch((e) => {
							console.log("FAILED LOGIN USER");
							console.log(e);
							Notie.error("Unauthorized", "Please check your username and password");
						});
				})
				.catch((e) => {
					console.log(e);
					Notie.error("Could not create account", e);
				});
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clickable-card {
	transition: transform 0.15s ease-in-out;
	background-color: #f7f7f7;
}
.clickable-card:hover {
	transform: scale(1.05);
}
.limited-width {
	max-width: 600px;
}
.code-entry {
	margin-left: auto;
	margin-right: auto;
	max-width: 650px;
	font-size: 72px;
	font-family: "Blender Pro";
}
.black-border {
	border: 2px solid rgb(128, 128, 128);
}

.login-box {
	max-width: 600px;
	border: 6px solid rgb(254, 80, 0);
	padding: 2rem 2rem;
	background-color: #f7f7f7;
}

.login-input {
	background-color: rgba(255, 255, 255, 0.25);
	border: 3px solid black;
	width: 100%;
	padding: 6px;
	font-size: 18px;
	font-weight: 800;
	text-align: center;
}

.login-input-disabled {
	border-color: rgba(0, 0, 0, 0.6);
	background-color: rgba(0, 0, 0, 0.05);
}
</style>
